import { CSSObject } from '@chakra-ui/react';

export const TabsContentContainer: CSSObject = {
  py: '0',
};
